(function (Drupal, once) {
  "use strict";

  // Unlink the top category level and the current (last) crumb.
  Drupal.behaviors.unlinkHcCategoriesCrumbs = {
    attach(context) {
      // Process each breadcrumb list once within the current context.
      once('unlink-hc-categories-crumbs', '.node--type-hs-article ol.breadcrumb', context).forEach((ol) => {
        const items = ol.querySelectorAll('li.breadcrumb-item');
        if (!items.length) return;

        // Unlink the 2nd item (top-level category) and thelast item (current page)
        const targetIndices = [1, items.length - 1];

        const unlink = (a) => {
          // Replace the <a> with a <span> to keep inline layout predictable.
          const span = document.createElement('span');
          // If you want to keep classes/appearance from the link, copy them:
          // span.className = a.className; // optional
          span.textContent = a.textContent || a.innerText || '';
          a.replaceWith(span);
        };

        for (const idx of targetIndices) {
          const li = items[idx];
          if (!li) continue;
          const link = li.querySelector('a');
          if (!link) continue;

          // Optional: only unlink taxonomy links that look like hc_categories.
          // Uncomment & adjust the condition if needed:
          // const href = link.getAttribute('href') || '';
          // if (!/\/taxonomy\/term\/|\/hc_categories\//.test(href)) continue;

          unlink(link);
        }
      });
    }
  };

})(Drupal, once);
